<template>
  <div id="app">
    <Header></Header>
    <router-view />
  </div>
</template>

<script>
import Header from "./components/global/header";

export default {
  name: "App",
  components: {
    Header,
  },
};
</script>

<style>
.anchorBL{
  display:none;
}

</style>




// WEBPACK FOOTER //
// src/App.vue